'use strict';
angular.module('schoolLinqApp').factory('prControlInfoService', [
	'$http',
	function ($http) {
		var endpoint = '/api/prcontrolinfo';

		function get() {
			return $http.get(endpoint);
		}

		function getValue(key) {
			return $http.get(endpoint + '/getValue', { params: { key: key } });
		}

		function getValueBinary(key) {
			return $http.get(endpoint + '/getValueBinary', { params: { key: key } });
		}

		function save(info) {
			return $http.post(endpoint, info);
		}

		function saveValue(key, value) {
			return $http.post(endpoint + '/postValue', { Key: key, Value: value });
		}

		function saveValueBinary(key, value) {
			return $http.post(endpoint + '/postValueBinary', {
				key: key,
				value: value,
			});
		}

		return {
			get: get,
			getValue: getValue,
			getValueBinary: getValueBinary,
			save: save,
			saveValue: saveValue,
			saveValueBinary: saveValueBinary,
		};
	},
]);
